import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  private r = inject(Router);
  private meta = inject(Meta);

  constructor() {
    this.r.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
      this.meta.updateTag({ property: 'og:title', content: "Careers at Graphisoft" });
      this.meta.updateTag({ property: 'og:url', content: "https://careers.graphisoft.com/" });
      this.meta.updateTag({ property: 'og:image', content: "https://careers.graphisoft.com/assets/i/default-facebook-image.png" });

      this.meta.updateTag({ name: 'twitter:site', content: "https://careers.graphisoft.com/" });
      this.meta.updateTag({ name: 'twitter:title', content: "Careers at Graphisoft" });
      this.meta.updateTag({ name: 'twitter:image', content: "https://careers.graphisoft.com/assets/i/default-facebook-image.png" });
    });
  }

  setMeta(title: any, url: any, img: any) {

    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:url', content: "https://careers.graphisoft.com" + url });
    this.meta.updateTag({ property: 'og:image', content: "https://careers.graphisoft.com/assets/i/job-images/" + img });

    this.meta.updateTag({ name: 'twitter:site', content: "https://careers.graphisoft.com" + url });
    this.meta.updateTag({ name: 'twitter:title', content: title });
    this.meta.updateTag({ name: 'twitter:image', content: "https://careers.graphisoft.com/assets/i/job-images/" + img });
  }

}
